module.exports = __webpack_public_path__ + "static/media/Deloitte.cff7aa2a.svg";